<template>
  <div
    v-if="filters?.length > 0"
    :class="[$attrs.class]"
    class="w-full max-w-[365px] rounded-l-xl bg-grey-200 p-6"
  >
    <div
      class="mb-5 flex items-center justify-between gap-2 text-lg font-semibold text-grey-900"
    >
      <span>Select Filters</span>
      <button @click="emitClose">
        <SquareClose class="h-5 w-5 cursor-pointer" />
      </button>
    </div>
    <div class="filters h-full overflow-auto border border-grey-600">
      <div v-for="item in filters" :key="item.name">
        <Expanded :title="item.name">
          <RangeNumberFilter
            v-if="item.type === 'number'"
            v-bind="item.props"
            :min-value="item.minValue"
            :max-value="item.maxValue"
            @change-min-value="changeMinValue(item.id, $event)"
            @change-max-value="changeMaxValue(item.id, $event)"
          />
          <SearchFilter v-if="item.type === 'list'" v-model="item.value" />
        </Expanded>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import Expanded from '~/components/filters/Expanded.vue'
import RangeNumberFilter from '~/components/filters/RangeNumberFilter.vue'
import SearchFilter from '~/components/filters/SearchFilter.vue'
import SquareClose from '~/assets/icons/SquareClose.svg'
import type { TFilter } from '~/src/types/markets'

const props = defineProps<{
  value: Array<TFilter>
}>()

const emit = defineEmits(['input', 'close'])

const filters = computed({
  get() {
    return props.value
  },
  set(value) {
    emit('input', value)
  },
})

const emitClose = () => {
  emit('close')
}

const changeMinValue = (id: string, minValue: number) => {
  const index = filters.value.findIndex((item) => item.id === id)
  if (index === -1) return
  filters.value.splice(index, 1, {
    ...filters.value[index],
    minValue,
  })
}

const changeMaxValue = (id: string, maxValue: number) => {
  const index = filters.value.findIndex((item) => item.id === id)
  if (index === -1) return
  filters.value.splice(index, 1, {
    ...filters.value[index],
    maxValue,
  })
}
</script>

<style scoped>
.filters {
  max-height: calc(100% - 48px);
}
</style>
